(function () {
  'use strict';

  var MOBILE_QUERY = window.matchMedia('(max-width: 960px)');
  var THRESHOLD_PATTERN = /UNLOCK FREE SHIPPING AT\s*\$?\d+|FREE RANGE TOTE BAG|RANGE TOTE BAG UNLOCKED|FREE DOMESTIC SHIPPING|FREE SHIPPING FOR ALL ORDERS/i;
  var BIS_PATTERN = /NOTIFY ME|BACK IN STOCK/i;
  var closeTimer = null;
  var refreshQueued = false;

  var TECH_IMAGES = [
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/ChatGPT_Image_Apr_21_2026_06_28_27_PM.png?v=1776821440',
      alt: 'Core Gi Dura-Pearl cotton-weave jacket construction',
      title: 'DURA-PEARL™ jacket',
      copy: '400 gsm cotton weave. Structured for daily training and built to hold up.'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/ChatGPT_Image_Apr_21_2026_06_34_54_PM.png?v=1776821715',
      alt: 'Core Gi Riptech ripstop pants construction',
      title: 'RIPTECH™ pants',
      copy: '10 oz ripstop. Light on the legs and reinforced where it counts.'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/ChatGPT_Image_Apr_21_2026_06_57_05_PM.png?v=1776823063',
      alt: 'Core Gi drawstring closure and reinforcement detail',
      title: 'Secure drawstring',
      copy: 'Matte black tips and a secure closure for training.'
    }
  ];

  var STORY_IMAGES = [
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/jjt-core-built-to-train-black-jacket.png?v=1792623023',
      alt: 'Black Core 2.0 gi jacket with lapel and fabric detail',
      title: 'Built to train.',
      copy: '400 gsm DURA-PEARL™ cotton weave with enough structure for daily training.'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/jjt-feature-spare-gi-pants.png?v=1792622369',
      alt: 'Folded black Core gi pants with drawcord and signature patch',
      title: 'Light on the legs.',
      copy: '10 oz RIPTECH™ pants keep the lower half lighter through guard work and passing.'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/ChatGPT_Image_May_7_2026_at_02_02_12_AM_5ccdfcca-2a21-45be-8a63-cd2b2bb8638a.png?v=1778149339',
      alt: 'Blue, white, black, and gray Core gi jackets hanging on a rack',
      title: 'Nothing extra.',
      copy: 'Minimal branding and reinforced stitching in high-wear areas.'
    }
  ];

  var OLIVE_FEATURE_IMAGES = [
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-feature-jacket-weave.png?v=1789170515',
      alt: 'Core Gi Olive 400 gsm DURA-PEARL jacket weave and lapel',
      title: 'DURA-PEARL™ jacket.',
      copy: '400 gsm cotton weave with a structured collar and reinforced lapel.'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-feature-athletic-fit.jpg?v=1789170519',
      alt: 'Core Gi Olive structured athletic fit',
      title: 'Structured athletic cut.',
      copy: 'Clean through the body with room to move, grip fight, and train.'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-feature-riptech-pants.jpg?v=1789170509',
      alt: 'Core Gi Olive 10 oz RIPTECH pants and drawcord',
      title: 'RIPTECH™ pants.',
      copy: '10 oz ripstop keeps the legs lighter through guard work, passing, and scrambles.'
    }
  ];

  var OLIVE_WORN_IMAGES = [
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-01.jpg?v=1789170535',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-02.jpg?v=1789170543',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-03.jpg?v=1789170539',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-04.jpg?v=1789170548',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-05.jpg?v=1789170566',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-06.jpg?v=1789170553',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-07.jpg?v=1789170557',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-08.jpg?v=1789170561',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-09.jpg?v=1789170571',
    'https://cdn.shopify.com/s/files/1/0262/4939/6327/files/core-gi-olive-worn-10.jpg?v=1789170575'
  ];

  function isOliveProduct() {
    return (window.jjProductData || {}).handle === 'core-gi-olive';
  }

  function configureProductMedia() {
    if (!isOliveProduct()) return;
    STORY_IMAGES = OLIVE_FEATURE_IMAGES.slice();
  }

  function qa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function productRoot() {
    return document.querySelector('.jj-lp');
  }

  function productInfo() {
    var data = window.jjProductData || {};
    var title = data.title || 'Core Gi';
    return {
      data: data,
      title: title,
      color: title.replace(/^Core Gi\s*/i, '').trim()
    };
  }

  function applyCopy(root) {
    var info = productInfo();
    setText(root.querySelector('.jj-tier'), 'Core series');
    setText(root.querySelector('.jj-title'), 'Core Gi');
    setText(root.querySelector('.jj-version'), '400 gsm DURA-PEARL™ cotton weave / 10 oz RIPTECH™ ripstop');
    setText(root.querySelector('.jj-info > .jj-sel-label'), info.color ? 'Color: ' + info.color : 'Color');
    setText(root.querySelector('.jj-sticky-name'), info.title);

    var badge = root.querySelector('.jjt-on-bestseller');
    if (!badge) {
      badge = make('span', 'jjt-on-bestseller', 'Bestseller');
    }
    var productTitle = root.querySelector('.jj-title');
    if (productTitle && productTitle.nextElementSibling !== badge) {
      productTitle.insertAdjacentElement('afterend', badge);
    }

    var subtitle = root.querySelector('.jjt-on-product-subtitle');
    if (subtitle) subtitle.remove();

    var priceRow = root.querySelector('.jj-price-row');
    var description = root.querySelector('.jj-desc');
    if (priceRow && description && priceRow.nextElementSibling !== description) {
      priceRow.insertAdjacentElement('afterend', description);
    }
    if (description) {
      var useCases = root.querySelector('.jjt-on-use-cases');
      if (!useCases) {
        useCases = make('div', 'jjt-on-use-cases');
        useCases.setAttribute('aria-label', 'Best for');
        useCases.innerHTML = '<span>Daily training</span><span>Lightweight gi</span>';
        description.insertAdjacentElement('beforebegin', useCases);
      }
      setText(description, 'The gi you’ll reach for most. A clean, dependable daily trainer with a structured jacket and lighter ripstop pants for easy movement.');
    }

    setText(root.querySelector('.jj-offer-kicker'), 'Included');
    setText(root.querySelector('.jj-offer-title'), 'Pro Belt included');
    setText(root.querySelector('.jj-offer-copy'), 'Choose belt rank and size after adding the gi.');

    qa('.jj-price, #jjPrice, #jjStickyPrice', root).forEach(function (price) {
      var clean = price.textContent.replace(/\s+USD\b/g, '').trim();
      setText(price, clean);
    });
  }

  function initBreadcrumbs(root) {
    if (root.querySelector('.jjt-on-breadcrumbs')) return;
    var tier = root.querySelector('.jj-tier');
    if (!tier || !tier.parentNode) return;
    var nav = make('nav', 'jjt-on-breadcrumbs');
    nav.setAttribute('aria-label', 'Breadcrumb');
    nav.innerHTML = '<a href="/collections/all">Shop</a><span>›</span><span>Gi</span><span>›</span><span>Core Gi</span>';
    tier.parentNode.insertBefore(nav, tier);
  }

  function placeBreadcrumbs() {
    var root = productRoot();
    var grid = root && root.querySelector('.jj-grid');
    var wrap = grid && grid.querySelector('#jjGalleryWrap');
    var info = grid && grid.querySelector('.jj-info');
    var breadcrumbs = root && root.querySelector('.jjt-on-breadcrumbs');
    if (!grid || !wrap || !info || !breadcrumbs) return;

    if (MOBILE_QUERY.matches) {
      breadcrumbs.hidden = true;
      return;
    }

    breadcrumbs.hidden = false;
    if (breadcrumbs.parentNode !== info || info.firstElementChild !== breadcrumbs) {
      info.insertAdjacentElement('afterbegin', breadcrumbs);
    }
  }

  function placeMobileColorRail() {
    var root = productRoot();
    var grid = root && root.querySelector('.jj-grid');
    var wrap = root && root.querySelector('#jjGalleryWrap');
    var gallery = wrap && wrap.querySelector('.jjt-on-gallery-final');
    var info = grid && grid.querySelector('.jj-info');
    var colors = root && root.querySelector('#jjSwatches');
    var label = colors && colors.previousElementSibling;
    if (!grid || !wrap || !gallery || !info || !colors || !label) return;

    var rail = root.querySelector('.jjt-on-mobile-color-rail');
    if (MOBILE_QUERY.matches) {
      if (!rail) {
        rail = make('section', 'jjt-on-mobile-color-rail');
        rail.setAttribute('aria-label', 'Core Gi colors');
      }
      if (rail.parentNode !== grid || wrap.nextElementSibling !== rail) {
        wrap.insertAdjacentElement('afterend', rail);
      }
      if (label.parentNode !== rail) rail.appendChild(label);
      if (colors.parentNode !== rail) rail.appendChild(colors);
      qa('.jj-swatch-link', colors).forEach(function (swatch) {
        var image = swatch.querySelector('img');
        var rawName = swatch.getAttribute('title') || (image && image.getAttribute('alt')) || '';
        var colorName = rawName
          .replace(/jiujiteiro/gi, '')
          .replace(/core\s*gi/gi, '')
          .replace(/\b(bjj|men'?s|women'?s)\b/gi, '')
          .replace(/\s+/g, ' ')
          .trim();
        if (!colorName) colorName = 'Color';
        var oldName = swatch.querySelector('.jjt-mobile-swatch-name');
        if (oldName) oldName.remove();
        swatch.dataset.colorName = colorName;
        if (swatch.dataset.mobileColorReady !== 'true') {
          swatch.dataset.mobileColorReady = 'true';
          swatch.addEventListener('click', function (event) {
            var href = swatch.getAttribute('href');
            if (!href || swatch.classList.contains('active')) return;
            event.preventDefault();
            event.stopPropagation();
            window.location.assign(href);
          });
        }
      });
      label.hidden = true;
      var activeSwatch = colors.querySelector('.jj-swatch-link.active');
      var activeColor = activeSwatch && activeSwatch.dataset.colorName || productInfo().color || 'Color';
      var activeLabel = rail.querySelector('.jjt-mobile-active-color');
      if (!activeLabel) {
        activeLabel = make('p', 'jjt-mobile-active-color');
        colors.insertAdjacentElement('afterend', activeLabel);
      }
      setText(activeLabel, activeColor);
      return;
    }

    if (rail) {
      label.hidden = false;
      var form = info.querySelector('.jj-product-form');
      if (form) {
        info.insertBefore(label, form);
        info.insertBefore(colors, form);
      } else {
        info.appendChild(label);
        info.appendChild(colors);
      }
      rail.remove();
    }
  }

  function initGallery(root) {
    var wrap = root.querySelector('#jjGalleryWrap');
    var data = productInfo().data;
    var images = Array.isArray(data.images) ? data.images : [];
    if (!wrap || !images.length || wrap.querySelector('.jjt-on-gallery-final')) return;

    qa('.jjt-on-gallery', wrap).forEach(function (gallery) {
      gallery.remove();
    });

    var gallery = make('div', 'jjt-on-gallery jjt-on-gallery-v3 jjt-on-gallery-final');
    var viewport = make('div', 'jjt-on-gallery-viewport');
    viewport.tabIndex = 0;
    viewport.setAttribute('role', 'region');
    viewport.setAttribute('aria-label', 'Product image gallery');

    var stage = make('div', 'jjt-on-gallery-single');
    var image = make('img', 'jjt-on-gallery-image');
    image.decoding = 'async';
    stage.appendChild(image);
    viewport.appendChild(stage);

    var controls = make('div', 'jjt-on-gallery-controls');
    var previous = make('button', 'jjt-on-gallery-arrow', '←');
    var next = make('button', 'jjt-on-gallery-arrow', '→');
    var count = make('span', 'jjt-on-gallery-count');
    previous.type = 'button';
    next.type = 'button';
    previous.setAttribute('aria-label', 'Previous product image');
    next.setAttribute('aria-label', 'Next product image');
    controls.appendChild(previous);
    controls.appendChild(next);
    controls.appendChild(count);
    gallery.appendChild(viewport);
    gallery.appendChild(controls);
    wrap.appendChild(gallery);

    var index = 0;
    var startX = null;

    function update() {
      index = Math.max(0, Math.min(index, images.length - 1));
      image.src = images[index].src;
      image.alt = images[index].alt || data.title || 'Core Gi';
      image.loading = index === 0 ? 'eager' : 'lazy';
      count.textContent = (index + 1) + ' / ' + images.length;
      previous.disabled = index === 0;
      next.disabled = index === images.length - 1;
    }

    previous.addEventListener('click', function () {
      index -= 1;
      update();
    });
    next.addEventListener('click', function () {
      index += 1;
      update();
    });
    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        index -= 1;
        update();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        index += 1;
        update();
      }
    });
    viewport.addEventListener('touchstart', function (event) {
      if (event.touches && event.touches.length) startX = event.touches[0].clientX;
    }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      if (startX === null || !event.changedTouches || !event.changedTouches.length) return;
      var distance = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(distance) < 45) return;
      index += distance < 0 ? 1 : -1;
      update();
    }, { passive: true });

    update();
  }

  function initSizeTrigger(root) {
    var sizes = root.querySelector('.jj-product-form .jj-sizes');
    if (!sizes) return;
    var trigger = sizes.previousElementSibling;
    if (!trigger || !trigger.classList.contains('jjt-on-size-trigger')) {
      trigger = make('button', 'jjt-on-size-trigger');
      trigger.type = 'button';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', sizes.id || 'jjSizes');
      trigger.appendChild(make('span', 'jjt-on-size-trigger-value'));
      sizes.parentNode.insertBefore(trigger, sizes);
    }
    if (trigger.dataset.ready === 'true') return;
    trigger.dataset.ready = 'true';

    var value = trigger.querySelector('.jjt-on-size-trigger-value');

    function updateValue() {
      var active = sizes.querySelector('.jj-sz.active');
      var label = active ? (active.getAttribute('data-size') || active.textContent || '').trim() : '';
      setText(value, label ? 'Size: ' + label : 'Select a size');
    }

    function close() {
      sizes.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    var sizeChartAction = sizes.querySelector('.jjt-on-size-chart-action');
    if (!sizeChartAction) {
      sizeChartAction = make('button', 'jjt-on-size-chart-action');
      sizeChartAction.type = 'button';
      sizeChartAction.innerHTML = '<span aria-hidden="true">▤</span><u>Size chart</u><b>Athletic fit</b>';
      sizes.appendChild(sizeChartAction);
      sizeChartAction.addEventListener('click', function () {
        close();
        var sizeFit = root.querySelector('.jjt-on-accordion[data-jjt-size-fit]');
        if (!sizeFit) return;
        sizeFit.open = true;
        var indicator = sizeFit.querySelector('.jjt-on-accordion-icon');
        setText(indicator, '−');
        sizeFit.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    trigger.addEventListener('click', function () {
      var open = !sizes.classList.contains('is-open');
      sizes.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    sizes.addEventListener('click', function (event) {
      var button = event.target.closest('.jj-sz');
      if (!button) return;
      window.setTimeout(function () {
        updateValue();
        close();
        refreshDynamic();
      }, 0);
    });
    document.addEventListener('click', function (event) {
      if (!sizes.classList.contains('is-open')) return;
      if (sizes.contains(event.target) || trigger.contains(event.target)) return;
      close();
    });

    var sizeObserver = new MutationObserver(updateValue);
    qa('.jj-sz', sizes).forEach(function (button) {
      sizeObserver.observe(button, { attributes: true, attributeFilter: ['class', 'disabled'] });
    });
    updateValue();
  }

  function initDetailBand(root) {
    if (root.querySelector('.jjt-on-detail-band')) return;
    var grid = root.querySelector('.jj-grid');
    if (!grid || !grid.parentNode) return;

    var band = make('section', 'jjt-on-detail-band');
    band.setAttribute('aria-label', 'Core Gi product details');
    function icon(name) {
      var template = document.querySelector('[data-jjt-icon-template="' + name + '"]');
      return template ? template.innerHTML : '';
    }
    band.innerHTML =
      '<div class="jjt-on-accordions">' +
        '<details class="jjt-on-accordion" data-jjt-size-fit><summary><span>SIZE &amp; FIT</span><span class="jjt-on-accordion-icon">+</span></summary><div class="jjt-on-accordion-content"><p class="jjt-on-fit-intro"><strong>Athletic training cut.</strong> Choose your usual Jiujiteiro size. Minor shrinkage may occur after washing. Wash cold and hang dry to preserve the intended fit.</p><div class="jjt-on-size-chart-mount"></div></div></details>' +
        '<details class="jjt-on-accordion"><summary><span>SHIPPING &amp; RETURNS</span><span class="jjt-on-accordion-icon">+</span></summary><div class="jjt-on-accordion-content">Free U.S. shipping over $150. Free size exchanges. 30-day returns on unworn, unwashed items with tags.</div></details>' +
        '<details class="jjt-on-accordion"><summary><span>MATERIALS &amp; CONSTRUCTION</span><span class="jjt-on-accordion-icon">+</span></summary><div class="jjt-on-accordion-content jjt-material-tab-content"></div></details>' +
      '</div>' +
      '<div class="jjt-on-tech-grid">' +
        '<div class="jjt-on-tech-item"><div class="jjt-on-tech-icon">' + icon('jacket') + '</div><div><div class="jjt-on-tech-label">Jacket</div><div class="jjt-on-tech-value">400 gsm</div></div></div>' +
        '<div class="jjt-on-tech-item"><div class="jjt-on-tech-icon">' + icon('pants') + '</div><div><div class="jjt-on-tech-label">Pants</div><div class="jjt-on-tech-value">10 oz</div></div></div>' +
        '<div class="jjt-on-tech-item"><div class="jjt-on-tech-icon">' + icon('fit') + '</div><div><div class="jjt-on-tech-label">Fit</div><div class="jjt-on-tech-value">Athletic</div></div></div>' +
      '</div>' +
      '<div class="jjt-on-key-features">' +
        '<h2 style="letter-spacing:-.008em!important">Key features</h2>' +
        '<ul>' +
          '<li>400 gsm DURA-PEARL™ cotton-weave jacket</li>' +
          '<li>10 oz RIPTECH™ ripstop pants</li>' +
          '<li>Athletic training cut</li>' +
          '<li>Reinforced stitching in high-wear areas</li>' +
          '<li>Minimal Jiujiteiro branding</li>' +
          '<li>Minor shrinkage may occur after washing</li>' +
          '<li>Jiujiteiro Pro Belt included</li>' +
        '</ul>' +
      '</div>' +
      '<div class="jjt-on-scales" aria-label="Core Gi performance profile">' +
        '<div class="jjt-on-scale"><div class="jjt-on-scale__heading"><span>Jacket weight</span><strong>3 / 5</strong></div><div class="jjt-on-scale__segments" aria-hidden="true"><i></i><i></i><i class="is-active"></i><i></i><i></i></div><div class="jjt-on-scale__ends"><span>Light</span><span>Substantial</span></div></div>' +
        '<div class="jjt-on-scale"><div class="jjt-on-scale__heading"><span>Structure</span><strong>3 / 5</strong></div><div class="jjt-on-scale__segments" aria-hidden="true"><i></i><i></i><i class="is-active"></i><i></i><i></i></div><div class="jjt-on-scale__ends"><span>Soft</span><span>Structured</span></div></div>' +
        '<div class="jjt-on-scale"><div class="jjt-on-scale__heading"><span>Durability</span><strong>4 / 5</strong></div><div class="jjt-on-scale__segments" aria-hidden="true"><i></i><i></i><i></i><i class="is-active"></i><i></i></div><div class="jjt-on-scale__ends"><span>Daily</span><span>Maximum</span></div></div>' +
      '</div>' +
      '<div class="jjt-on-story-grid" aria-label="Core Gi construction highlights"></div>';
    grid.parentNode.insertBefore(band, grid.nextSibling);

    var storyGrid = band.querySelector('.jjt-on-story-grid');
    STORY_IMAGES.forEach(function (item, index) {
      var figure = make('figure', 'jjt-on-story-card');
      figure.innerHTML =
        '<img src="' + item.src + '" alt="' + item.alt + '" loading="lazy" width="1200" height="1200">' +
        '<figcaption><span>' + String(index + 1).padStart(2, '0') + '</span><strong>' + item.title + '</strong><p>' + item.copy + '</p></figcaption>';
      storyGrid.appendChild(figure);
    });

    var existingSizeSection = root.querySelector('#jjSizeChart');
    var existingSizePanel = existingSizeSection && existingSizeSection.querySelector('.jj-size-panel');
    var sizeChartMount = band.querySelector('.jjt-on-size-chart-mount');
    if (existingSizePanel && sizeChartMount) {
      sizeChartMount.appendChild(existingSizePanel);
      existingSizeSection.hidden = true;
      existingSizeSection.setAttribute('aria-hidden', 'true');
    }

    var materialContent = band.querySelector('.jjt-material-tab-content');
    materialContent.innerHTML =
      '<dl class="jjt-material-specs">' +
        '<div><dt>Jacket</dt><dd>400 gsm DURA-PEARL™ cotton weave</dd></div>' +
        '<div><dt>Pants</dt><dd>10 oz RIPTECH™ ripstop</dd></div>' +
        '<div><dt>Fit</dt><dd>Athletic training cut</dd></div>' +
        '<div><dt>Details</dt><dd>Minimal branding and reinforced stitching</dd></div>' +
        '<div><dt>Use</dt><dd>Daily training</dd></div>' +
        '<div><dt>Care</dt><dd>Wash cold. Hang dry. Minor shrinkage may occur after washing.</dd></div>' +
      '</dl>' +
      '<div class="jjt-material-macros">' +
        '<figure class="jjt-material-macro"><img src="' + TECH_IMAGES[0].src + '" alt="' + TECH_IMAGES[0].alt + '" loading="lazy" width="1200" height="1200"><figcaption><strong>' + TECH_IMAGES[0].title + '</strong><span>' + TECH_IMAGES[0].copy + '</span></figcaption></figure>' +
        '<figure class="jjt-material-macro"><img src="' + TECH_IMAGES[1].src + '" alt="' + TECH_IMAGES[1].alt + '" loading="lazy" width="1200" height="1200"><figcaption><strong>' + TECH_IMAGES[1].title + '</strong><span>' + TECH_IMAGES[1].copy + '</span></figcaption></figure>' +
      '</div>';

    qa('.jjt-on-accordion', band).forEach(function (details) {
      var summary = details.querySelector('summary');
      var icon = details.querySelector('.jjt-on-accordion-icon');
      if (summary) {
        summary.style.setProperty('min-height', '80px', 'important');
        summary.style.setProperty('font-size', '17px', 'important');
        summary.style.setProperty('letter-spacing', '.075em', 'important');
      }
      if (icon) {
        icon.style.setProperty('width', '38px', 'important');
        icon.style.setProperty('height', '38px', 'important');
        icon.style.setProperty('font-size', '38px', 'important');
      }
      details.addEventListener('toggle', function () {
        var indicator = details.querySelector('.jjt-on-accordion-icon');
        setText(indicator, details.open ? '−' : '+');
      });
    });
  }

  function initOliveVideo(root) {
    if (!isOliveProduct() || root.querySelector('.jjt-olive-video')) return;

    var section = make('section', 'jjt-olive-video');
    section.setAttribute('aria-label', 'Core Gi Olive product film');
    section.innerHTML =
      '<video autoplay loop muted playsinline preload="metadata" aria-label="Core Gi Olive in training">' +
        '<source src="https://cdn.shopify.com/videos/c/vp/d922b59db32f45dd9e7223540d1de948/d922b59db32f45dd9e7223540d1de948.HD-1080p-7.2Mbps-95396419.mp4" type="video/mp4">' +
        '<source src="https://cdn.shopify.com/videos/c/vp/d922b59db32f45dd9e7223540d1de948/d922b59db32f45dd9e7223540d1de948.SD-480p-1.5Mbps-95396419.mp4" type="video/mp4">' +
      '</video>';
    root.appendChild(section);
  }

  function placeOliveVideo() {
    var root = productRoot();
    var video = root && root.querySelector('.jjt-olive-video');
    var band = root && root.querySelector('.jjt-on-detail-band');
    var story = root && root.querySelector('.jjt-on-story-grid');
    if (!root || !video || !band || !story) return;

    if (MOBILE_QUERY.matches) {
      if (band.nextElementSibling !== video) band.insertAdjacentElement('afterend', video);
      return;
    }

    if (story.nextElementSibling !== video) story.insertAdjacentElement('afterend', video);
  }

  function initOliveWornGallery(root) {
    if (!isOliveProduct() || root.querySelector('.jjt-olive-worn')) return;

    var section = make('section', 'jjt-olive-worn');
    section.setAttribute('aria-label', 'Core Gi Olive worn gallery');
    section.innerHTML =
      '<div class="jjt-olive-worn__header">' +
        '<div><span>Core Gi Olive</span><h2>On the mat.</h2></div>' +
        '<div class="jjt-olive-worn__controls">' +
          '<button type="button" data-jjt-olive-prev aria-label="Previous image">←</button>' +
          '<button type="button" data-jjt-olive-next aria-label="Next image">→</button>' +
        '</div>' +
      '</div>' +
      '<div class="jjt-olive-worn__rail" tabindex="0"></div>';

    var rail = section.querySelector('.jjt-olive-worn__rail');
    OLIVE_WORN_IMAGES.forEach(function (src, index) {
      var figure = make('figure', 'jjt-olive-worn__slide');
      figure.innerHTML = '<img src="' + src + '" alt="Core Gi Olive worn in the academy – image ' + (index + 1) + '" loading="lazy" width="1856" height="2304">';
      rail.appendChild(figure);
    });

    function move(direction) {
      var slide = rail.querySelector('.jjt-olive-worn__slide');
      var distance = slide ? slide.getBoundingClientRect().width + 12 : rail.clientWidth * 0.82;
      rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    section.querySelector('[data-jjt-olive-prev]').addEventListener('click', function () { move(-1); });
    section.querySelector('[data-jjt-olive-next]').addEventListener('click', function () { move(1); });
    root.appendChild(section);
  }

  function placeOliveWornGallery() {
    var root = productRoot();
    var section = root && root.querySelector('.jjt-olive-worn');
    var grid = root && root.querySelector('.jj-grid');
    var band = root && root.querySelector('.jjt-on-detail-band');
    var story = root && root.querySelector('.jjt-on-story-grid');
    var video = root && root.querySelector('.jjt-olive-video');
    if (!root || !section || !grid || !band || !story || !video) return;

    if (video.nextElementSibling !== section) video.insertAdjacentElement('afterend', section);
  }

  function placeDetailBand() {
    var root = productRoot();
    var grid = root && root.querySelector('.jj-grid');
    var wrap = root && root.querySelector('#jjGalleryWrap');
    var info = grid && grid.querySelector('.jj-info');
    var gallery = wrap && wrap.querySelector(':scope > .jjt-on-gallery');
    var band = root && root.querySelector('.jjt-on-detail-band');
    if (!grid || !wrap || !info || !gallery || !band) return;

    if (MOBILE_QUERY.matches) {
      if (band.parentNode !== grid.parentNode || grid.nextElementSibling !== band) {
        grid.insertAdjacentElement('afterend', band);
      }
      return;
    }

    if (band.parentNode !== wrap || gallery.nextElementSibling !== band) {
      gallery.insertAdjacentElement('afterend', band);
    }
  }

  function placeStoryGrid() {
    var root = productRoot();
    var grid = root && root.querySelector('.jj-grid');
    var band = root && root.querySelector('.jjt-on-detail-band');
    var scales = band && band.querySelector('.jjt-on-scales');
    var story = root && root.querySelector('.jjt-on-story-grid');
    if (!grid || !band || !story) return;

    if (MOBILE_QUERY.matches) {
      story.classList.remove('jjt-on-story-grid--full');
      if (story.parentNode !== band || (scales && scales.nextElementSibling !== story)) {
        if (scales) scales.insertAdjacentElement('afterend', story);
        else band.appendChild(story);
      }
      return;
    }

    story.classList.add('jjt-on-story-grid--full');
    if (story.parentNode !== grid.parentNode || grid.nextElementSibling !== story) {
      grid.insertAdjacentElement('afterend', story);
    }
  }

  function updateStory(root) {
    var imageCards = root.querySelectorAll('.jj-material-section .jj-material-image-card');
    var infoCards = root.querySelectorAll('.jj-material-section .jj-material-info-card');
    STORY_IMAGES.forEach(function (item, index) {
      var image = imageCards[index] && imageCards[index].querySelector('img');
      var title = infoCards[index] && infoCards[index].querySelector('.jj-material-title');
      var copy = infoCards[index] && infoCards[index].querySelector('.jj-material-copy');
      if (image && image.src !== item.src) {
        image.src = item.src;
        image.alt = item.alt;
        image.loading = 'lazy';
      }
      setText(title, item.title);
      setText(copy, item.copy);
    });

    setText(root.querySelector('.jj-size-panel-kicker'), 'Size guide');
    setText(root.querySelector('.jj-size-panel-title'), 'Find your size.');
    setText(root.querySelector('.jj-size-panel-copy'), 'Choose your usual Jiujiteiro size. Minor shrinkage may occur after washing. Wash cold and hang dry to preserve the intended fit.');

    var calloutTitle = root.querySelector('.jj-callout-title');
    if (calloutTitle) calloutTitle.innerHTML = 'Pack it.<br>Train. Repeat.';
    setText(root.querySelector('.jj-callout-text'), 'The gi that stays in rotation.');
    setText(root.querySelector('.jj-callout-btn'), 'Choose your size ↑');

    qa('.jj-sec-label', root).forEach(function (label) {
      if (label.textContent.trim().toLowerCase() === 'complete the uniform') setText(label, 'Finish the kit');
    });
    setText(root.querySelector('.jj-kit-intro'), 'The belt is included. Add the layers you train in.');

    var kitCopy = [
      'Included. Choose your rank after adding the gi.',
      'Built for sweat, friction and hard rounds.',
      'Support under the pants. Nothing extra.'
    ];
    qa('.jj-kit-desc', root).forEach(function (description, index) {
      if (kitCopy[index]) setText(description, kitCopy[index]);
    });
  }

  function wireChrome() {
    var search = document.querySelector('[data-jjt-on-search]');
    var cart = document.querySelector('[data-jjt-on-cart]');
    var mobileMenu = document.querySelector('[data-jjt-mobile-product-menu]');
    if (search && search.dataset.ready !== 'true') {
      search.dataset.ready = 'true';
      search.addEventListener('click', function () {
        var original = document.querySelector('.js-search-header');
        if (original) original.click();
      });
    }
    if (cart && cart.dataset.ready !== 'true') {
      cart.dataset.ready = 'true';
      cart.addEventListener('click', function () {
        var original = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
        if (original) original.click();
      });
    }
    if (mobileMenu && mobileMenu.dataset.ready !== 'true') {
      mobileMenu.dataset.ready = 'true';
      mobileMenu.addEventListener('click', function () {
        var original = document.querySelector('[data-jjt-mobile-dock] [data-jjt-dock-menu], .js-drawer-open-nav, [aria-controls="NavDrawer"], [data-drawer-open="nav"]');
        if (original) original.click();
      });
    }
  }

  function setupMegaNavigation() {
    var triggers = qa('[data-jjt-mega-trigger]');
    var mega = document.querySelector('[data-jjt-mega]');
    var backdrop = document.querySelector('[data-jjt-mega-backdrop]');
    var mobileProductMenu = document.querySelector('[data-jjt-mobile-product-menu]');
    if (!triggers.length || !mega || !backdrop || mega.dataset.ready === 'true') return;
    mega.dataset.ready = 'true';

    function clearClose() {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    function closeMega() {
      clearClose();
      mega.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.classList.remove('jjt-mega-open');
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      qa('[data-jjt-mega-panel]', mega).forEach(function (panel) {
        panel.classList.remove('is-active');
      });
    }

    function openMega(key) {
      clearClose();
      var panel = mega.querySelector('[data-jjt-mega-panel="' + key + '"]');
      if (!panel) return;
      qa('[data-jjt-mega-panel]', mega).forEach(function (item) {
        item.classList.toggle('is-active', item === panel);
      });
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', trigger.dataset.jjtMegaTrigger === key ? 'true' : 'false');
      });
      mega.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.classList.add('jjt-mega-open');
    }

    function scheduleClose() {
      clearClose();
      closeTimer = window.setTimeout(closeMega, 180);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        if (!MOBILE_QUERY.matches) openMega(trigger.dataset.jjtMegaTrigger);
      });
      trigger.addEventListener('focus', function () {
        if (!MOBILE_QUERY.matches) openMega(trigger.dataset.jjtMegaTrigger);
      });
      trigger.addEventListener('click', function () {
        var key = trigger.dataset.jjtMegaTrigger;
        if (trigger.getAttribute('aria-expanded') === 'true') closeMega();
        else openMega(key);
      });
      trigger.addEventListener('mouseleave', scheduleClose);
    });

    mega.addEventListener('mouseenter', clearClose);
    mega.addEventListener('mouseleave', scheduleClose);
    backdrop.addEventListener('click', closeMega);
    qa('[data-jjt-mega-close]', mega).forEach(function (button) {
      button.addEventListener('click', closeMega);
    });
    qa('a', mega).forEach(function (link) {
      link.addEventListener('click', closeMega);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMega();
    });
    MOBILE_QUERY.addEventListener('change', function () {
      if (MOBILE_QUERY.matches) closeMega();
    });
  }

  function relocateThresholds() {
    var root = productRoot();
    var form = root && root.querySelector('.jj-product-form');
    if (!root || !form) return;

    qa('[data-jjt-hitsy-pdp-mount], [data-jjt-pdp-shipping-bar]', form).forEach(function (node) {
      node.remove();
    });

    qa('hitsy-container', document).forEach(function (node) {
      if (!node.closest('.jj-lp, .product-form, .product-info')) return;
      node.classList.add('jjt-pdp-hitsy-replaced');
      node.setAttribute('aria-hidden', 'true');
      node.style.setProperty('display', 'none', 'important');
    });
  }

  function cleanHitsyToteLabel(host) {
    var shadow = host && host.shadowRoot;
    if (!shadow) return;
    function clean() {
      var walker = document.createTreeWalker(shadow, NodeFilter.SHOW_TEXT);
      var textNode;
      while ((textNode = walker.nextNode())) {
        var value = (textNode.textContent || '').replace(/\s+/g, ' ').trim();
        if (!/^(FREE\s+)?(RANGE\s+)?TOTE(\s+BAG)?$/i.test(value)) continue;
        var parent = textNode.parentElement;
        if (!parent) continue;
        var color = window.getComputedStyle(parent).color;
        if (color === 'rgb(255, 255, 255)' || color === 'rgba(255, 255, 255, 1)') {
          parent.style.setProperty('display', 'none', 'important');
          parent.setAttribute('aria-hidden', 'true');
        }
      }
    }
    clean();
    if (host.dataset.jjtToteCleanReady !== 'true') {
      host.dataset.jjtToteCleanReady = 'true';
      new MutationObserver(clean).observe(shadow, { childList: true, subtree: true, characterData: true });
      [100, 350, 900, 1800].forEach(function (delay) {
        window.setTimeout(clean, delay);
      });
    }
  }

  function suppressInjectedBis(root) {
    var form = root && root.querySelector('.jj-product-form');
    if (!form) return;
    qa('a, button, [role="button"]', form).forEach(function (node) {
      if (node.matches('.jj-btn-atc') || node.closest('[data-jjt-bis-modal]')) return;
      var signal = [node.className, node.id, node.getAttribute('data-testid'), node.textContent].join(' ');
      if (!BIS_PATTERN.test(signal) && !/klaviyo.*bis|bis.*klaviyo/i.test(signal)) return;
      node.classList.add('jjt-injected-bis-hidden');
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('tabindex', '-1');
    });
  }

  function simplifyPayment(root) {
    var payment = root.querySelector('.jj-pay-note');
    if (!payment) return;
    var price = root.querySelector('.jj-price');
    var number = price ? parseFloat((price.textContent || '').replace(/[^0-9.]/g, '')) : 0;
    var amount = number ? '$' + (number / 4).toFixed(2) : '$37.50';
    var currentAmount = payment.querySelector('#jjInstallmentAmount');
    var currentLink = payment.querySelector('.jjt-on-pay-link');
    if (currentAmount && currentLink && currentAmount.textContent.trim() === amount) return;
    payment.innerHTML = '<div class="jjt-on-pay-main">4 interest-free payments of <strong id="jjInstallmentAmount">' + amount + '</strong></div><span class="jjt-on-pay-link">Payment options at checkout</span>';
  }

  function activeSizeText(root) {
    var active = root.querySelector('.jj-product-form .jj-sizes .jj-sz.active');
    var label = active ? (active.getAttribute('data-size') || active.textContent || '').trim() : '';
    return label ? 'Size ' + label : 'Select a size';
  }

  function syncMobileSticky(root) {
    var sticky = document.querySelector('[data-jjt-mobile-sticky]');
    var mainButton = root.querySelector('.jj-product-form .jj-btn-atc');
    var price = root.querySelector('.jj-price');
    if (!sticky || !mainButton) return;
    var active = root.querySelector('.jj-product-form .jj-sizes .jj-sz.active');
    var select = sticky.querySelector('[data-jjt-mobile-size-select]');
    if (select && active) select.value = active.dataset.variantId;
    if (price) setText(sticky.querySelector('[data-jjt-mobile-price]'), price.textContent.trim());
    var button = sticky.querySelector('[data-jjt-mobile-atc]');
    if (button) {
      var soldOut = !!(active && active.classList.contains('soldout'));
      setText(button, soldOut ? 'Notify me' : (/pre-order/i.test(mainButton.textContent) ? 'Pre-order' : 'Add to bag'));
      button.disabled = false;
      button.dataset.notify = soldOut ? 'true' : 'false';
    }
  }

  function setupMobileSticky(root) {
    var sticky = document.querySelector('[data-jjt-mobile-sticky]');
    var mainButton = root.querySelector('.jj-product-form .jj-btn-atc');
    var stickyButton = sticky && sticky.querySelector('[data-jjt-mobile-atc]');
    if (!sticky || !mainButton || !stickyButton || sticky.dataset.ready === 'true') return;
    sticky.dataset.ready = 'true';

    var select = sticky.querySelector('[data-jjt-mobile-size-select]');
    if (select && window.jjProductData && Array.isArray(window.jjProductData.variants)) {
      select.innerHTML = window.jjProductData.variants.map(function (variant) {
        return '<option value="' + variant.id + '">' + variant.title + (variant.available ? (variant.preorder ? ' / Pre-order' : '') : ' / Notify me') + '</option>';
      }).join('');
      select.addEventListener('change', function () {
        var sizeButton = root.querySelector('.jj-product-form .jj-sz[data-variant-id="' + select.value + '"]');
        if (sizeButton && window.jjSelectSize) window.jjSelectSize(sizeButton);
      });
    }

    stickyButton.addEventListener('click', function () {
      if (stickyButton.dataset.notify === 'true') openBisModal(root);
      else mainButton.click();
    });

    function setVisibility() {
      var shouldShow = MOBILE_QUERY.matches;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    var intersectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setVisibility(entry.isIntersecting);
      });
    }, { threshold: 0.15 });
    intersectionObserver.observe(mainButton);
    setVisibility(false);

    MOBILE_QUERY.addEventListener('change', function () {
      if (!MOBILE_QUERY.matches) {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
      placeDetailBand();
      syncMobileSticky(root);
    });

    syncMobileSticky(root);
  }

  function selectedVariant(root) {
    var active = root.querySelector('.jj-product-form .jj-sizes .jj-sz.active');
    var id = active && active.dataset.variantId;
    var variants = window.jjProductData && window.jjProductData.variants;
    var variant = Array.isArray(variants) ? variants.find(function (item) {
      return String(item.id) === String(id);
    }) : null;
    if (variant) return variant;
    if (!active || !id) return null;
    return {
      id: id,
      available: !active.classList.contains('soldout'),
      preorder: active.dataset.preorder === 'true'
    };
  }

  function syncBisAction(root) {
    var variant = selectedVariant(root);
    var mainButton = root.querySelector('.jj-product-form .jj-btn-atc');
    if (!variant || !mainButton) return;
    root.classList.toggle('jjt-selected-sold-out', !variant.available);
    if (!variant.available) {
      mainButton.style.setProperty('display', 'flex', 'important');
      mainButton.disabled = false;
      mainButton.dataset.notify = 'true';
      setText(mainButton, 'Notify me');
    } else {
      mainButton.style.removeProperty('display');
      if (mainButton.dataset.notify === 'true') {
        delete mainButton.dataset.notify;
        setText(mainButton, variant.preorder ? 'Pre-order' : 'Add to bag');
      }
    }
  }

  function openBisModal(root) {
    var modal = document.querySelector('[data-jjt-bis-modal]');
    if (!modal) return;
    var variant = selectedVariant(root);
    modal.dataset.variantId = variant ? variant.id : '';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var email = modal.querySelector('input[type="email"]');
    if (email) window.setTimeout(function () { email.focus(); }, 50);
  }

  function setupBis(root) {
    var modal = document.querySelector('[data-jjt-bis-modal]');
    var form = modal && modal.querySelector('[data-jjt-bis-form]');
    if (!modal || !form || modal.dataset.ready === 'true') return;
    modal.dataset.ready = 'true';
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); }
    qa('[data-jjt-bis-close]', modal).forEach(function (button) { button.addEventListener('click', close); });
    document.addEventListener('click', function (event) {
      var clickedButton = event.target && event.target.closest
        ? event.target.closest('.jj-product-form .jj-btn-atc')
        : null;
      if (!clickedButton || !root.contains(clickedButton)) return;
      var variant = selectedVariant(root);
      if (variant && !variant.available) { event.preventDefault(); event.stopImmediatePropagation(); openBisModal(root); }
    }, true);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = form.querySelector('input[type="email"]');
      var status = form.querySelector('[data-jjt-bis-status]');
      var variantId = modal.dataset.variantId;
      if (!email || !email.validity.valid || !variantId) return;
      status.textContent = 'Submitting…';
      var body = new URLSearchParams({ a: 'S5XVBX', email: email.value.trim(), variant: variantId, platform: 'shopify' });
      fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', { method:'POST', mode:'no-cors', headers:{'Content-Type':'application/x-www-form-urlencoded'}, body:body.toString() })
        .then(function () { status.textContent = 'You’re on the list. We’ll email you when it’s back.'; form.reset(); })
        .catch(function () { status.textContent = 'Please try again in a moment.'; });
    });
  }

  function suppressRedoLauncher() {
    var host = document.querySelector('#redo-chat-widget');
    var button = host && host.shadowRoot && host.shadowRoot.querySelector('#chat-widget-button, [aria-label="Open chat widget"]');
    if (button) button.style.setProperty('display', 'none', 'important');
  }

  function enforceAddToBag(root) {
    var button = root.querySelector('.jj-product-form .jj-btn-atc');
    var variant = selectedVariant(root);
    if (!button || button.disabled || button.dataset.notify === 'true' || (variant && !variant.available)) return;
    var preorder = root.querySelector('.jj-preorder-notice.visible');
    setText(button, preorder ? 'Pre-order' : 'Add to bag');
  }

  function refreshDynamic() {
    var root = productRoot();
    if (!root) return;
    relocateThresholds();
    suppressInjectedBis(root);
    enforceAddToBag(root);
    simplifyPayment(root);
    syncMobileSticky(root);
    placeDetailBand();
    placeBreadcrumbs();
    placeMobileColorRail();
    placeStoryGrid();
    placeOliveVideo();
    placeOliveWornGallery();
    suppressRedoLauncher();
    syncBisAction(root);
  }

  function queueDynamicRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(function () {
      refreshQueued = false;
      refreshDynamic();
    });
  }

  function init() {
    var root = productRoot();
    if (!root || root.dataset.onFinalReady === 'true') return;
    root.dataset.onFinalReady = 'true';

    configureProductMedia();
    applyCopy(root);
    initBreadcrumbs(root);
    placeBreadcrumbs();
    initGallery(root);
    initSizeTrigger(root);
    initDetailBand(root);
    updateStory(root);
    wireChrome();
    setupMegaNavigation();
    placeDetailBand();
    placeMobileColorRail();
    placeStoryGrid();
    initOliveVideo(root);
    placeOliveVideo();
    initOliveWornGallery(root);
    placeOliveWornGallery();
    relocateThresholds();
    suppressInjectedBis(root);
    simplifyPayment(root);
    enforceAddToBag(root);
    setupMobileSticky(root);
    setupBis(root);
    syncBisAction(root);
    suppressRedoLauncher();

    var form = root.querySelector('.jj-product-form');
    if (form) {
      var formObserver = new MutationObserver(queueDynamicRefresh);
      formObserver.observe(form, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
    }

    var bodyObserver = new MutationObserver(queueDynamicRefresh);
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', function () {
      placeDetailBand();
      placeBreadcrumbs();
      placeMobileColorRail();
      placeStoryGrid();
      placeOliveVideo();
      placeOliveWornGallery();
    });
    [150, 600, 1400, 3000].forEach(function (delay) {
      window.setTimeout(queueDynamicRefresh, delay);
    });
  }

  function queueInit() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(init);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueInit, { once: true });
  } else {
    queueInit();
  }
})();
